import * as actionTypes from "./actionTypes";

export const getEvents = (first, limit, refresh = false) => ({
    type: actionTypes.GET_EVENTS,
    first,
    limit,
    refresh
});

export const getEventsSucceeded = (events, first, refresh = false) => ({
    type: actionTypes.GET_EVENTS_SUCCEEDED,
    events,
    first,
    refresh
});

export const getEventsFail = () => ({
    type: actionTypes.GET_EVENTS_FAIL,
});

export const resetEvents = () => ({
    type: actionTypes.RESET_EVENTS
});

export const selectEvent = (eventID) => ({
    type: actionTypes.SELECT_EVENT,
    eventID
});
